module.exports = __webpack_public_path__ + "img/header-weddingRings@2x.f0a85d1.webp";